module.exports = __webpack_public_path__ + "img/zhengshu3.d64945f2.jpg";